import { render } from "./order.vue?vue&type=template&id=45068125&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"

import "./order.vue?vue&type=style&index=0&id=45068125&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45068125"],['__file',"resources/js/components/whatsapp-managment/includes/types/order.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45068125"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45068125', __exports__)) {
    console.log('reload')
    api.reload('45068125', __exports__)
  }
  
  module.hot.accept("./order.vue?vue&type=template&id=45068125&scoped=true", () => {
    console.log('re-render')
    api.rerender('45068125', render)
  })

}


export default __exports__